import { mapEntityProperties } from '@/utils/mapEntityProperties'
import type { DriverRankSettingsAdminDto } from '@/backend/market'
import { DriverRankSettingEntity } from '../../domain/entities/DriverRankSettingEntity'

export class DriverRankSettingModel extends DriverRankSettingEntity {
  constructor(data: DriverRankSettingsAdminDto) {
    super()
    mapEntityProperties(this, data)
  }
}
